module.exports = __webpack_public_path__ + "img/logoServiciosCarlys.e61eec30.jpg";